




















import Vue from "vue";

export default Vue.extend({
  name: "JobTitle",
  props: {
    title: {
      type: String,
      required: true
    },
    employment_type: {
      required: true
    }
  }
});
